import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ContactsModalComponent } from './contacts-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputMaskModule } from '@ngneat/input-mask';
import { BusContactModalComponent } from '../../bus-contacts/bus-contact-modal/bus-contact-modal.component';
import { RefereeModalComponent } from '../../referee-contacts/referee-modal/referee-modal.component';
import { FacilityModalComponent } from '../../field-facility/facility-modal/facility-modal.component';
import { AdminsModalComponent } from '../../manage-admins/admins-modal/admins-modal.component';

@NgModule({
  declarations: [ContactsModalComponent, BusContactModalComponent, RefereeModalComponent, FacilityModalComponent, AdminsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    InputMaskModule,
  ],
  exports: [ContactsModalComponent, BusContactModalComponent, RefereeModalComponent, FacilityModalComponent, AdminsModalComponent]
})
export class ContactsModalCommonPageModule { }
